/**
 * Abstract transport interface for chat session streaming.
 * Provides a consistent contract for connect/disconnect/resume/send/cancel.
 */
export class ChatTransport {
  connect(sessionId, options) {
    throw new Error("not implemented");
  }
  disconnect() {
    throw new Error("not implemented");
  }
  resume(sessionId, lastEventId) {
    throw new Error("not implemented");
  }
  send(sessionId, message) {
    throw new Error("not implemented");
  }
  cancel(sessionId) {
    throw new Error("not implemented");
  }
}
